// Paper.js never passes willReadFrequently; patch 2d contexts when the GTO lazy chunk loads.

type GetContextFn = HTMLCanvasElement['getContext'];

function merge2dOptions(existing: unknown): CanvasRenderingContext2DSettings {
  if (existing === undefined) {
    return { willReadFrequently: true };
  }
  if (typeof existing === 'boolean') {
    return { alpha: existing, willReadFrequently: true };
  }
  if (existing !== null && typeof existing === 'object') {
    return { ...(existing as CanvasRenderingContext2DSettings), willReadFrequently: true };
  }
  return { willReadFrequently: true };
}

const proto = HTMLCanvasElement.prototype;
const original = proto.getContext as GetContextFn & { __gtoPaper2dPatched?: boolean };

if (!original.__gtoPaper2dPatched) {
  const native = original as (
    this: HTMLCanvasElement,
    contextId: string,
    ...rest: unknown[]
  ) => RenderingContext | null;

  const patched = function (
    this: HTMLCanvasElement,
    contextId: string,
    ...args: unknown[]
  ): RenderingContext | null {
    if (contextId === '2d') {
      return native.call(this, contextId, merge2dOptions(args[0]));
    }
    return native.call(this, contextId, ...args);
  };

  original.__gtoPaper2dPatched = true;
  proto.getContext = patched as GetContextFn;
}
